import { v4 as uuidv4 } from "uuid";
import { getLoggedStatus } from "../helpers";
import { getAffiliationFromHotel } from "./getAffiliation";

const addToCartEvent = (
  hotel,
  currentRoom,
  roomRenderedPrice,
  search,
  roomIndex,
  eventPage
): void => {
  const brandName =
    hotel.relationships &&
    hotel.relationships.brand_id &&
    hotel.relationships.brand_id.name;
  const totalRooms = search?.rooms?.length;
  const checkinDate = new Date(search.checkin);
  const checkoutDate = new Date(search.checkout);
  const room = currentRoom.room;
  const rate = currentRoom.rate;
  const lengthOfStay = Math.ceil(
    (checkoutDate - checkinDate) / (1000 * 60 * 60 * 24)
  );

  const totalAdults = search.rooms.reduce((sum, r) => sum + r.adults, 0);
  const totalChildren = search.rooms.reduce((sum, r) => sum + r.children, 0);
  const totalGuests = totalAdults + totalChildren;

  const itemObject = {
    item_id: room.code,
    item_name: room.name,
    index: (roomIndex || 0) + 1,
    quantity: lengthOfStay,
    coupon: search?.promotionCode || search?.groupCode || "",
    currency: rate?.currencyCode,
    item_hotel_brand: brandName,
    item_hotel_name: hotel.name,
    item_hotel_id: hotel.crs_code,
    item_list_id: "Product Listing",
    item_category: "Room",
    item_list_name: eventPage,
    start_date: search?.checkin,
    end_date: search?.checkout,
    adults: currentRoom?.adults,
    children: currentRoom?.children,
    total_guest: currentRoom.adults + currentRoom.children,
  };

  const loggedState = getLoggedStatus();
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: "addtocart",
    ecommerce: {
      event_id: uuidv4(),
      value: parseFloat(roomRenderedPrice).toFixed(2),
      currency: rate?.currencyCode,
      coupon: search?.promotionCode || search?.groupCode || "",
      hotel_brand: brandName,
      hotel_name: hotel.name,
      hotel_id: hotel.crs_code,
      check_in_date: search?.checkin,
      check_out_date: search?.checkout,
      adults: totalAdults,
      children: totalChildren,
      total_guest: totalGuests,
      length_of_stay: lengthOfStay,
      rooms: totalRooms,
      affiliation: getAffiliationFromHotel(hotel),
      city: hotel.address?.locality,
      list_id: "Product Listing",
      category: "Room",
      list_name:
        window && window._purchaseStartPage
          ? window._purchaseStartPage
          : eventPage,
      loggedState: loggedState,
      items: [
        {
          ...itemObject,
          price: parseFloat(roomRenderedPrice).toFixed(2),
        },
      ],
    },
  });
};

export default addToCartEvent;
